import { render } from "./NotPermission.vue?vue&type=template&id=2d856f69"
import script from "./NotPermission.vue?vue&type=script&lang=js"
export * from "./NotPermission.vue?vue&type=script&lang=js"

import "./NotPermission.vue?vue&type=style&index=0&id=2d856f69&lang=scss"

import exportComponent from "../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__